import React from 'react';
import { Button } from 'antd';

const Footer = ({ onCancel, onSubmit, isEdit, isLoading }) => {
  return (
    <>
      <Button onClick={onCancel} disabled={isLoading}>
        Отмена
      </Button>
      <Button
        type="primary"
        onClick={onSubmit}
        loading={isLoading}
        disabled={isLoading}
      >
        {isEdit ? 'Изменить' : 'Добавить'}
      </Button>
    </>
  );
};

export default Footer;
